import React from 'react';
import DOMPurify from 'dompurify';
import type { CmdbObjectAttributeValueDefault } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute-values.tsx';
import type { CmdbObjectAttributeDefault } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';
import { ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS } from '@atlassian/jira-servicedesk-insight-shared-utils/src/common/constants.tsx';

const sanitize = (html: string): string =>
	DOMPurify.sanitize(html, {
		// @ts-expect-error - TS2769 - No overload matches this call.
		ALLOWED_TAGS: ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS,
		ALLOWED_ATTR: ['role', 'tabindex', 'href', 'target'],
	});

export type Props = {
	attribute: CmdbObjectAttributeDefault;
};

const GenericTextAttribute = (props: {
	attribute: CmdbObjectAttributeDefault;
	isRichText?: boolean;
}) => {
	const { attribute, isRichText = false } = props;

	const renderText = (value: CmdbObjectAttributeValueDefault, index: number) => {
		if (isRichText) {
			return (
				<div
					key={index}
					data-testId="insight-attribute-list-text-attribute-text"
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{ __html: sanitize(value.displayValue) }}
				/>
			);
		}
		return <div key={index}>{value.value}</div>;
	};

	return <>{attribute.objectAttributeValues.map(renderText)}</>;
};

export const TextAttribute = (props: Props): React.JSX.Element => (
	<GenericTextAttribute {...props} />
);

export const RichTextAttribute = (props: Props): React.JSX.Element => (
	<GenericTextAttribute {...props} isRichText />
);
